<template>
  <RouterView :key="key" />
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { useExplorerStore } from '@/features/explorer/store'
import { useRoute } from 'vue-router'
import { Table } from '@dacr/ui'
import { TableTypes } from '@/shared/types'
import {
  GuidanceActionState,
  GuidanceId,
  useMeQuery,
} from '@/shared/graphql/legacy/generated'
import type { Item } from '@/shared/graphql/router/graphql'
import { isFile } from '@/features/explorer/utils/itemGuards'
import { useUserStore } from '@/shared/stores/user'
import { useDialog } from '@/shared/dialogs/useDialog'
import { Dialogs } from '@/shared/dialogs/types'

const { refetch } = useMeQuery()

const route = useRoute()
const explorerStore = useExplorerStore()
const table = Table.useTable(TableTypes.Explorer)
const userStore = useUserStore()
const { open, isOpen } = useDialog()

const selectedItems = computed(
  () =>
    (explorerStore.currentFolder?.items || []).filter((item) =>
      table.isRowSelected(item.id)
    ) as Item[]
)

const key = computed(() => route.path + explorerStore.currentFolder?.name)

const tipToShow = computed(() =>
  userStore.user?.guidanceStates.states.find(
    (state) => state.state.state === GuidanceActionState.Show
  )
)

const hasOneProcessedFile = computed(() =>
  explorerStore.currentFolder?.items.find(
    (item) => isFile(item) && item.copyright?.registrations?.[0]?.timestamp
  )
)

const showTip = () => {
  return !isOpen.value && route.path.includes('home')
}

watch(
  [tipToShow, hasOneProcessedFile],
  () => {
    if (!tipToShow.value && hasOneProcessedFile.value) {
      refetch()
    }

    if (!showTip()) return

    if (tipToShow.value?.id === GuidanceId.WelcomeModal) {
      setTimeout(() => {
        if (!showTip()) return

        open(Dialogs.UploadTip)
      }, 3000)
    }

    if (
      tipToShow.value?.id === GuidanceId.CopyrightModal &&
      hasOneProcessedFile.value &&
      showTip()
    ) {
      open(Dialogs.CopyrightPageTip)
    }
  },
  {
    deep: true,
    immediate: true,
  }
)
</script>
